// Variables to store the state of applied filters
var lastAppliedTypes = [];
var lastAppliedYears = [];
  
document.addEventListener('DOMContentLoaded', function() {
  var openBtns = document.querySelectorAll('.mobile-facets__open');
  var blurOverlay = document.querySelector('.archives-blur');

  openBtns.forEach(function(openBtn) {
    openBtn.addEventListener('click', function() {
      var archivesContainer = openBtn.closest('.archives');
      if (!archivesContainer) return;
      var isOpen = archivesContainer.classList.contains('open');
      if (!isOpen) {
        openArchivesModal(archivesContainer);
      } else {
        closeArchivesModal(archivesContainer, true);
      }
    });
  });

  // Optional: close on outside click
  document.addEventListener('click', function(e) {
    document.querySelectorAll('.archives.open').forEach(function(archivesContainer) {
      var filterContainer = archivesContainer.querySelector('.archives-filter-container');
      var openBtn = archivesContainer.querySelector('.mobile-facets__open');
      // Removed the 'open' class check on filterContainer
      if (
        filterContainer &&
        !filterContainer.contains(e.target) &&
        !openBtn.contains(e.target)
      ) {
        closeArchivesModal(archivesContainer, true);
      }
    });
  });

  function updateFooterVisibility() {
    var footer = document.querySelector('.mobile-facets__footer');
    var activeFilters = document.querySelector('.archives-filter-container .active');
    if (footer) {
      footer.style.display = activeFilters ? '' : 'none';
    }
  }

  // Centralized function to apply filters
  function applyFilters(applyAndClose) {
    // Update button counts
    var activeTypes = Array.from(document.querySelectorAll('.archives-filter-type.active')).map(function(el) {
      return el.getAttribute('data-type');
    }).filter(Boolean);
    var activeYears = Array.from(document.querySelectorAll('.archives-filter-year.active')).map(function(el) {
      return el.getAttribute('data-year');
    }).filter(Boolean);
    var shownCount = 0;
    // Calculate how many items would be shown with the current filters
    document.querySelectorAll('.archives-list__grid').forEach(function(grid) {
      var type = grid.querySelector('.archive-type[data-type]')?.getAttribute('data-type');
      var year = grid.querySelector('.archive-year[data-year]')?.getAttribute('data-year');
      var typeMatch = !activeTypes.length || (type && activeTypes.includes(type));
      var yearMatch = !activeYears.length || (year && activeYears.includes(year));
      if (typeMatch && yearMatch) {
        shownCount++;
      }
    });
    var applyBtn = document.querySelector('.apply-filters-button');
    var removeBtn = document.querySelector('.remove-filters-button');
    if (applyBtn) {
      if (activeTypes.length || activeYears.length) {
        const applyBtnHTML = (applyBtn.dataset.baseLabel || applyBtn.textContent) + ' (' + shownCount + ')';
        applyBtn.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(applyBtnHTML) : applyBtnHTML;
      } else {
        const applyBtnHTML = applyBtn.dataset.baseLabel || applyBtn.textContent;
        applyBtn.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(applyBtnHTML) : applyBtnHTML;
      }
    }
    if (removeBtn) {
      var activeCount = activeTypes.length + activeYears.length;
      if (!removeBtn.dataset.baseLabel) {
        removeBtn.dataset.baseLabel = removeBtn.textContent.trim();
      }
      if (activeCount > 0) {
        const removeBtnHTML = removeBtn.dataset.baseLabel + ' (' + activeCount + ')';
        removeBtn.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(removeBtnHTML) : removeBtnHTML;
      } else {
        const removeBtnHTML = removeBtn.dataset.baseLabel;
        removeBtn.innerHTML = window.DOMPurify ? window.DOMPurify.sanitize(removeBtnHTML) : removeBtnHTML;
      }
    }
    // Update active filter count
    var count = document.querySelectorAll('.archives-filter-type.active, .archives-filter-year.active').length;
    var countSpan = document.querySelector('.archives-filter-active-count');
    if (countSpan) {
      countSpan.textContent = count > 0 ? '(' + count + ')' : '';
    }
    // If applying and closing
    if (applyAndClose) {
      // Filter the list
      document.querySelectorAll('.archives-list__grid').forEach(function(grid) {
        var type = grid.querySelector('.archive-type[data-type]')?.getAttribute('data-type');
        var year = grid.querySelector('.archive-year[data-year]')?.getAttribute('data-year');
        var typeMatch = !activeTypes.length || (type && activeTypes.includes(type));
        var yearMatch = !activeYears.length || (year && activeYears.includes(year));
        if (typeMatch && yearMatch) {
          grid.style.display = '';
        } else {
          grid.style.display = 'none';
        }
      });
      // Update applied state
      lastAppliedTypes = [...activeTypes];
      lastAppliedYears = [...activeYears];
      // Close the modal
      var archivesContainer = applyBtn ? applyBtn.closest('.archives') : null;
      closeArchivesModal(archivesContainer, false);
    }
    // Update filter availability
    updateFilterAvailability();
    updateFooterVisibility();
  }

  function updateFilterAvailability() {
    // Get all possible type/year combinations from visible archives
    var visibleTypes = new Set();
    var visibleYears = new Set();
    var activeTypes = Array.from(document.querySelectorAll('.archives-filter-type.active')).map(el => el.getAttribute('data-type'));
    var activeYears = Array.from(document.querySelectorAll('.archives-filter-year.active')).map(el => el.getAttribute('data-year'));

    // If a type is selected, only consider archives with that type; same for year
    document.querySelectorAll('.archives-list__grid').forEach(function(grid) {
      var type = grid.querySelector('.archive-type[data-type]')?.getAttribute('data-type');
      var year = grid.querySelector('.archive-year[data-year]')?.getAttribute('data-year');
      var typeMatch = !activeTypes.length || (type && activeTypes.includes(type));
      var yearMatch = !activeYears.length || (year && activeYears.includes(year));
      if (typeMatch && yearMatch) {
        if (type) visibleTypes.add(type);
        if (year) visibleYears.add(year);
      }
    });

    // Disable type filters that have no visible archives for the current year filter
    document.querySelectorAll('.archives-filter-type').forEach(function(typeEl) {
      var type = typeEl.getAttribute('data-type');
      if (activeYears.length) {
        // Only enable if this type exists in visibleTypes
        if (!visibleTypes.has(type) && !typeEl.classList.contains('active')) {
          typeEl.classList.add('disabled');
          typeEl.setAttribute('aria-disabled', 'true');
        } else {
          typeEl.classList.remove('disabled');
          typeEl.removeAttribute('aria-disabled');
        }
      } else {
        // Always enable if no year filter
        typeEl.classList.remove('disabled');
        typeEl.removeAttribute('aria-disabled');
      }
    });

    // Disable year filters that have no visible archives for the current type filter
    document.querySelectorAll('.archives-filter-year').forEach(function(yearEl) {
      var year = yearEl.getAttribute('data-year');
      if (activeTypes.length) {
        if (!visibleYears.has(year) && !yearEl.classList.contains('active')) {
          yearEl.classList.add('disabled');
          yearEl.setAttribute('aria-disabled', 'true');
        } else {
          yearEl.classList.remove('disabled');
          yearEl.removeAttribute('aria-disabled');
        }
      } else {
        yearEl.classList.remove('disabled');
        yearEl.removeAttribute('aria-disabled');
      }
    });
  }

  // Store base label for apply and remove buttons
  var applyBtn = document.querySelector('.apply-filters-button');
  if (applyBtn) {
    applyBtn.dataset.baseLabel = applyBtn.textContent.trim();
  }
  var removeBtn = document.querySelector('.remove-filters-button');
  if (removeBtn) {
    removeBtn.dataset.baseLabel = removeBtn.textContent.trim();
    removeBtn.addEventListener('click', function() {
      document.querySelectorAll('.archives-filter-type.active, .archives-filter-year.active').forEach(function(item) {
        item.classList.remove('active');
      });
      applyFilters(true);
    });
  }


  // Apply button closes the filters container
  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
      applyFilters(true);
    });
  }

  document.querySelectorAll('.archives-filter-type, .archives-filter-year').forEach(function(item) {
    item.addEventListener('click', function(e) {
      if (item.classList.contains('disabled')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.stopPropagation();
      item.classList.toggle('active');
      applyFilters(false);
    });
  });

  // Initial state
  applyFilters(false);

  // Show image on hover by injecting/removing the image element
  document.querySelectorAll('.archives-list__grid').forEach(function(grid) {
    var sidebar = grid.querySelector('.archives-list__sidebar');
    var imageUrl = grid.getAttribute('data-image');
    var imgEl = null;

    grid.addEventListener('mouseenter', function() {
      if (imageUrl && sidebar && !sidebar.querySelector('.archive-image')) {
        imgEl = document.createElement('img');
        imgEl.src = imageUrl;
        imgEl.alt = '';
        imgEl.className = 'archive-image';
        imgEl.style.width = '100%';
        imgEl.style.height = 'auto';
        sidebar.appendChild(imgEl);
      }
    });

    grid.addEventListener('mouseleave', function() {
      if (sidebar) {
        var img = sidebar.querySelector('.archive-image');
        if (img) sidebar.removeChild(img);
      }
    });
  });

  // Floating image column logic (inside .archives-list)
  (function() {
    var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    var archivesList = document.querySelector('.archives-list');
    if (!archivesList) return;

    var floatingCol = archivesList.querySelector('.archives-image-floating-col');
    if (!floatingCol) {
      floatingCol = document.createElement('div');
      floatingCol.className = 'archives-image-floating-col';
      archivesList.appendChild(floatingCol);
    }
    var floatingImg = null;

    function enableDesktopHover() {
      document.querySelectorAll('.archives-list__grid').forEach(function(grid) {
        var imageUrl = grid.getAttribute('data-image');
        grid.onmouseenter = function() {
          if (imageUrl && floatingCol) {
            floatingCol.innerHTML = '';
            floatingImg = document.createElement('img');
            floatingImg.src = imageUrl;
            floatingImg.alt = '';
            floatingImg.className = 'archive-image-floating';
            floatingCol.appendChild(floatingImg);
          }
        };
      });
      floatingCol.style.display = '';
    }

    function disableDesktopHover() {
      document.querySelectorAll('.archives-list__grid').forEach(function(grid) {
        grid.onmouseenter = null;
        grid.onmouseleave = null;
      });
      if (floatingCol) floatingCol.style.display = 'none';
    }

    function handleResponsive() {
      isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      if (isDesktop) {
        enableDesktopHover();
      } else {
        disableDesktopHover();
      }
    }

    handleResponsive();
    // Mostrar a primeira imagem na coluna flutuante se não houver nenhuma visível (apenas na primeira execução em desktop)
    if (isDesktop && floatingCol && !floatingCol.querySelector('img')) {
      var firstGrid = archivesList.querySelector('.archives-list__grid');
      if (firstGrid) {
        var firstImageUrl = firstGrid.getAttribute('data-image');
        if (firstImageUrl) {
          floatingCol.innerHTML = '';
          var firstImg = document.createElement('img');
          firstImg.src = firstImageUrl;
          firstImg.alt = '';
          firstImg.className = 'archive-image-floating';
          floatingCol.appendChild(firstImg);
        }
      }
    }
    window.addEventListener('resize', handleResponsive);
  })();

  // Custom sort dropdown logic with sorting functionality
  (function() {
    var sortDropdowns = document.querySelectorAll('.custom-sort-dropdown');
    if (!sortDropdowns.length) return;
    var archivesList = document.querySelector('.archives-list');
    var archiveGrids = Array.from(document.querySelectorAll('.archives-list__grid'));

    sortDropdowns.forEach(function(sortDropdown) {
      var label = sortDropdown.querySelector('.label-regular-s.uppercase, .label-regular-m.md\\:label-regular-s.uppercase');
      var arrow = sortDropdown.querySelector('.svg-wrapper');
      var list = sortDropdown.querySelector('.custom-sort-list');
      var items = list.querySelectorAll('li');

      function closeDropdown() {
        list.style.display = 'none';
        sortDropdown.classList.remove('open');
      }

      [label, arrow, sortDropdown].forEach(function(el) {
        if (el) {
          el.addEventListener('click', function(e) {
            e.stopPropagation();
            if (list.style.display === 'block') {
              closeDropdown();
            } else {
              list.style.display = 'block';
              sortDropdown.classList.add('open');
            }
          });
        }
      });

      items.forEach(function(item) {
        item.addEventListener('click', function(e) {
          e.stopPropagation();
          items.forEach(function(i) { i.classList.remove('active'); });
          item.classList.add('active');
          closeDropdown();
          sortArchives(item.getAttribute('data-sort'));
        });
      });
    });

    document.addEventListener('click', function() {
      sortDropdowns.forEach(function(sortDropdown) {
        var list = sortDropdown.querySelector('.custom-sort-list');
        if (list) {
          list.style.display = 'none';
          sortDropdown.classList.remove('open');
        }
      });
    });

    function sortArchives(sortType) {
      var visibleGrids = archiveGrids.filter(function(grid) {
        return grid.style.display !== 'none';
      });

      var sorted = visibleGrids.slice();

      if (sortType === 'year-asc' || sortType === 'year-desc') {
        sorted.sort(function(a, b) {
          var yearA = parseInt(a.querySelector('.archive-year[data-year]')?.getAttribute('data-year') || 0, 10);
          var yearB = parseInt(b.querySelector('.archive-year[data-year]')?.getAttribute('data-year') || 0, 10);
          if (isNaN(yearA)) yearA = 0;
          if (isNaN(yearB)) yearB = 0;
          return sortType === 'year-asc' ? yearA - yearB : yearB - yearA;
        });
      } else if (sortType === 'az' || sortType === 'za') {
        sorted.sort(function(a, b) {
          var titleAEl = a.querySelector('.archive-title');
          var titleBEl = b.querySelector('.archive-title');
          var titleA = titleAEl ? titleAEl.textContent.trim().toLowerCase() : '';
          var titleB = titleBEl ? titleBEl.textContent.trim().toLowerCase() : '';
          if (titleA < titleB) return sortType === 'az' ? -1 : 1;
          if (titleA > titleB) return sortType === 'az' ? 1 : -1;
          return 0;
        });
      }

      // Update displayed order
      sorted.forEach(function(grid) {
        if (grid.parentNode) {
          grid.parentNode.appendChild(grid);
        }
      });
    }
  })();

  // Add event listener to close icon in filter modal
  document.querySelectorAll('.archives-filter-container .icon-close').forEach(function(closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      var archivesContainer = closeBtn.closest('.archives');
      // fallback: if not found, try parentNode
      if (!archivesContainer) archivesContainer = document.querySelector('.archives');
      closeArchivesModal(archivesContainer, true);
    });
  });

  // Utility function to close the filter modal
  function closeArchivesModal(archivesContainer, restoreFilters = false) {
    if (!archivesContainer) return;

    var archivesFilters = document.querySelector('.archives-filters');
    if (archivesFilters) {
      archivesFilters.classList.add('header-transition')
    }

    archivesContainer.classList.remove('open');
    document.body.style.overflow = '';
    if (blurOverlay) blurOverlay.classList.remove('active');
    if (typeof iconPlus !== 'undefined' && typeof iconMinus !== 'undefined') {
      iconPlus.style.display = '';
      iconMinus.style.display = 'none';
    }
    // If restoreFilters is true, visually restore filters to the last applied state
    if (restoreFilters) {
      // Remove all active filters
      document.querySelectorAll('.archives-filter-type.active, .archives-filter-year.active').forEach(function(item) {
        item.classList.remove('active');
      });
      // Activate saved types
      lastAppliedTypes.forEach(function(type) {
        var el = document.querySelector('.archives-filter-type[data-type="' + type + '"]');
        if (el) el.classList.add('active');
      });
      // Activate saved years
      lastAppliedYears.forEach(function(year) {
        var el = document.querySelector('.archives-filter-year[data-year="' + year + '"]');
        if (el) el.classList.add('active');
      });
      // Update disabled state and UI of buttons/counters
      updateFilterAvailability();
      applyFilters(false);
    }
  }

  // Utility function to open the filter modal
  function openArchivesModal(archivesContainer) {
    if (!archivesContainer) return;

    var archivesFilters = document.querySelector('.archives-filters');
    if (archivesFilters) {
      archivesFilters.classList.remove('header-transition')
    }
    
    // Open the modal immediately
    archivesContainer.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (blurOverlay) blurOverlay.classList.add('active');
    
    // Calculate positioning and set immediately without animation
    var archivesFilters = document.querySelector('.archives-filters');
    var archivesFilterContainer = document.querySelector('.archives-filter-container');
    
    if (archivesFilters && archivesFilterContainer) {
      var viewportHeight = window.innerHeight;
      var filtersRect = archivesFilters.getBoundingClientRect();
      var containerRect = archivesFilterContainer.getBoundingClientRect();
      
      // Calculate all distances and values
      var distanceFromTop = filtersRect.top;
      var distanceToViewportBottom = viewportHeight - filtersRect.bottom;
      var containerHeight = containerRect.height;
      var needsScroll = distanceToViewportBottom < containerHeight;
      var scrollDifference = needsScroll ? containerHeight - distanceToViewportBottom + 20 : 0;
      
      // Calculate the final top position accounting for scroll
      var finalTopPosition = needsScroll ? distanceFromTop - scrollDifference : distanceFromTop;

      // Set the overlay clip-path to only show below the filter container
      var filterBottom = finalTopPosition + containerHeight;
      document.documentElement.style.setProperty('--filter-bottom', filterBottom + 'px');

      // Apply positioning immediately without transition
      archivesFilterContainer.style.top = finalTopPosition + 'px';
      
      // Scroll if needed (can keep smooth scroll for page)
      if (needsScroll && scrollDifference > 0) {
        window.scrollBy({ 
          top: scrollDifference, 
          behavior: 'smooth' 
        });
      }
    } else {
      console.error('Could not find .archives-filters or .archives-filter-container');
    }
  }
});
